export const removeAccentsFromAString = (string) => {
  const stringToClear = String(string);
  return stringToClear.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
